import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast, Toaster } from 'react-hot-toast';
import apiService from '../services/api';
import './Admission.css';

const Admission = () => {
  const { referralPartnerId } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    class: '',
    school: '',
    mobile: '',
    whatsapp: '',
    email: '',
    preferred_country: '',
    preferred_university: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    const requiredFields = [
      'name',
      'location',
      'class',
      'mobile',
      'whatsapp',
      'email',
      'preferred_country',
      'preferred_university',
    ];
    const missingFields = requiredFields.filter((field) => !formData[field].trim());

    if (missingFields.length > 0) {
      toast.error('Please fill in all required fields.');
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('Please enter a valid email address.');
      return;
    }

    // Validate phone number
    const phoneRegex = /^[\d\s\+\-\(\)]{10,}$/;
    if (!phoneRegex.test(formData.mobile)) {
      toast.error('Please enter a valid phone number.');
      return;
    }

    setIsLoading(true);
    try {
      await apiService.submitPublicAdmission(
        {
          name: formData.name,
          location: formData.location,
          class: formData.class,
          school: formData.school,
          mobile: formData.mobile,
          whatsapp: formData.whatsapp,
          email: formData.email,
          preferred_country: formData.preferred_country,
          preferred_university: formData.preferred_university,
        },
        referralPartnerId
      );

      toast.success(
        'Your application has been submitted successfully! You will receive a confirmation email shortly.'
      );
      setFormData({
        name: '',
        location: '',
        class: '',
        school: '',
        mobile: '',
        whatsapp: '',
        email: '',
        preferred_country: '',
        preferred_university: '',
      });
    } catch (error) {
      console.error('Error:', error);
      const errorMessage =
        error.message || 'There was an error submitting your application. Please try again.';
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='admission-page'>
      <Toaster position='top-right' />
      {/* Header Section */}

      {/* Form Section */}
      <div className='form-container'>
        <div className='enquiry-contact-form-1542'>
          <div className='form-wrapper'>
            <div className='form-header'>
              <h2>Enquiry Form</h2>
            </div>

            <form onSubmit={handleSubmit}>
              <div className='form-row'>
                <div>
                  <label className='form-label'>Name</label>
                  <input
                    type='text'
                    name='name'
                    className='form-input'
                    placeholder='Enter your Name'
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div>
                  <label className='form-label'>Location</label>
                  <input
                    type='text'
                    name='location'
                    className='form-input'
                    placeholder='Enter your location'
                    value={formData.location}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className='form-row'>
                <div>
                  <label className='form-label'>Class</label>
                  <select
                    name='class'
                    className='form-select'
                    value={formData.class}
                    onChange={handleInputChange}
                    required
                  >
                    <option value=''>-- Select Class --</option>
                    <option value='Grade 11'>Grade 11</option>
                    <option value='Grade 12'>Grade 12</option>
                    <option value='Grade 12 completed'>Grade 12 completed</option>
                    <option value='Others'>Others</option>
                  </select>
                </div>
                <div>
                  <label className='form-label'>School (Grade 12)</label>
                  <input
                    type='text'
                    name='school'
                    className='form-input'
                    placeholder='Enter your school name'
                    value={formData.school}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className='form-row'>
                <div>
                  <label className='form-label'>Mobile Number</label>
                  <input
                    type='tel'
                    name='mobile'
                    className='form-input'
                    placeholder='Enter your mobile number'
                    value={formData.mobile}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div>
                  <label className='form-label'>WhatsApp Number</label>
                  <input
                    type='tel'
                    name='whatsapp'
                    className='form-input'
                    placeholder='Enter your WhatsApp number'
                    value={formData.whatsapp}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className='form-row'>
                <div>
                  <label className='form-label'>Email</label>
                  <input
                    type='email'
                    name='email'
                    className='form-input'
                    placeholder='Enter your email'
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div>
                  <label className='form-label'>Preferred Country</label>
                  <select
                    name='preferred_country'
                    className='form-select'
                    value={formData.preferred_country}
                    onChange={handleInputChange}
                    required
                  >
                    <option value=''>-- Select Country --</option>
                    <option value='Egypt'>Egypt</option>
                    <option value='Georgia'>Georgia</option>
                    <option value='Armenia'>Armenia</option>
                  </select>
                </div>
              </div>

              <div className='form-row'>
                <div>
                  <label className='form-label'>Preferred University</label>
                  <select
                    name='preferred_university'
                    className='form-select'
                    value={formData.preferred_university}
                    onChange={handleInputChange}
                    required
                  >
                    <option value=''>-- Select University --</option>
                    <option value='Cairo (Egypt)'>Cairo (Egypt)</option>
                    <option value='Ain Shams (Egypt)'>Ain Shams (Egypt)</option>
                    <option value='Port Said (Egypt)'>Port Said (Egypt)</option>
                    <option value='Alexandria (Egypt)'>Alexandria (Egypt)</option>
                    <option value='Nahda (Egypt)'>Nahda (Egypt)</option>
                    <option value='AAST (Egypt)'>AAST (Egypt)</option>
                    <option value='European University (Georgia)'>
                      European University (Georgia)
                    </option>
                    <option value='UTMA (Armenia)'>UTMA (Armenia)</option>
                  </select>
                </div>
              </div>

              <div className='form-row full-width'>
                <button type='submit' className='submit-button' disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <span className='loader'></span>
                      Submitting...
                    </>
                  ) : (
                    'Submit Application'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admission;
